import { useMemo } from 'react';
import { sanitizeAudioUrl } from 'utils/url-sanitizer';

export default function useSanitizedAudioSrc(
  audioUrl: string | undefined,
): string | undefined {
  return useMemo(() => audioUrl && sanitizeAudioUrl(audioUrl), [audioUrl]);
}
